import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			color: ({ usePaperColors }) => theme.palette.getTextColors(usePaperColors).secondary,
			display: 'block',
		},
		checkbox: {
			color: theme.palette.primary.main,
		},
		label: {
			paddingTop: theme.spacing(0.3),
			...theme.typography.caption,
			fontSize: theme.spacing(2),
		},
		error: {
			left: theme.spacing(3.4),
			marginTop: theme.spacing(-0.9),
		},
	}),
	{ name: 'Form-Checkbox' },
)

export default useStyles
